import styled from 'styled-components'
import { SubTitle } from './SubTitle'

const TranslatedSubTitle = styled(SubTitle)`
  font-family: 'Quicksand';
  font-weight: 200;
`

export { TranslatedSubTitle }
